// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"01e989fa","27":"84bbb63e","163":"728c2461","341":"d9cafae0","680":"38def6b4","752":"df918070","779":"35c159cc","845":"de2e6e62","947":"ceff3e74"}[chunkId] + ".chunk.js";
};